import { grey500, text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_light,
  font_family_weight_regular,
  font_size_xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.PricingFeaturesComparisonTable {
    width: 100%;
    max-width: calc(398px * 3 + ${spacing(8)} * 2);
    font-family: ${font_family_weight_light};
    color: ${text_colorTextPrimary};
    font-size: ${font_size_xl};
    line-height: 22px;

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }

    thead th {
      font-family: ${font_family_weight_regular};
      font-weight: bold;
      font-style: normal;
      position: sticky;
      top: 0;
      background: white;
      z-index: 1;
    }

    th,
    td {
      padding: ${spacing(6)} ${spacing(8)} ${spacing(6)} 0;
      text-align: left;
    }

    tr {
      border-bottom: 1px solid ${grey500};
    }

    .ComparisonTable-icon {
      display: flex;
      align-items: center;
    }
  }
`
